<template>
  <div ref="ProfitLossDashboardpdf" id="ProfitLossDashboardpdf">
    <div>
      <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
      <!-- <loading
        :active.sync="isLoading"
        loader="spinner"
        color="#36304a"
        :width="70"
      ></loading> -->
    </div>

    <div class="mt-3 mr-1">
      <div>
        <b-navbar>
          <b-navbar-brand style="padding: 0.475rem 1rem">
            <h3>Assignment P&L Dashboard</h3>
          </b-navbar-brand>
          <b-navbar-nav class="pull-right mr-auto">
            <b-nav-form>
              <Filter-Agency-Modal v-if="$sessionsStorage.get('is_Mobile') != 'port'" />
              <FilterCBModal v-if="$sessionsStorage.get('is_Mobile') != 'port'" />
              <ClientCard />
               <ShipmentTrackCard />
            </b-nav-form>
          </b-navbar-nav>
        </b-navbar>

        <div v-if="visible">
          <b-card>
            <b-collapse v-model="visible" id="collapse-2">
              <b-row>
                <b-col md="3">
                  <label>Type</label>
                  <model-list-select
                    :list="CustomDateList"
                    v-model="Filter.QDFilter"
                    option-value="DVal"
                    option-text="DText"
                    placeholder="Select"
                    :isDisabled="Filter.QFlag"
                    @input="getCurrentLastDate"
                  ></model-list-select>
                </b-col>
                <b-col md="3">
                  <label>Date</label>
                  <date-range-picker
                    :always-show-calendars="showCal"
                    v-model="Filter.dateRange"
                    :startDate="startDate"
                    :endDate="endDate"
                    :locale-data="locale"
                    :disabled="Filter.DFlag ? true : false"
                    @update="getProfitLossData('Normal')"
                  ></date-range-picker>
                </b-col>

                <b-col md="3"
                  ><label>Assignment Date</label
                  ><b-form-input
                    type="date"
                    id="ass_date-datepicker"
                    v-model="Filter.ass_date"
                    placeholder="YYYY-MM-DD"
                    autocomplete="off"
                /></b-col>
                <b-col md="3">
                  <label>SOB Date</label>
                  <b-form-input
                    type="date"
                    :formatter="capitalizeAll"
                    placeholder="Select SOB Date"
                    id="newClientName"
                    name="newClientName"
                    autocomplete="off"
                    v-model="Filter.sob_date"
                  ></b-form-input>
                </b-col>

                <b-col md="3">
                  <label>Branch</label>
                  <model-list-select
                    :list="$store.getters['common/getAllBranchList']"
                    id="branchfilter"
                    v-model="Filter.branchfilter"
                    option-value="pickupId"
                    option-text="pickupLocation"
                    placeholder="All"
                    @input="getProfitLossData('Normal')"
                    :isDisabled="
                      $sessionsStorage.get('designation') != 'Admin' ? true : false
                    "
                  ></model-list-select>
                </b-col>

                <b-col md="3">
                  <label>Client</label>
                  <model-list-select
                    :list="$store.getters['common/getAllClientList']"
                    id="clientfilter"
                    v-model="Filter.clientfilter"
                    option-value="clientId"
                    option-text="clientName"
                    placeholder="Select Client Name"
                    @input="getProfitLossData('Normal')"
                  ></model-list-select>
                </b-col>
                <b-col md="3">
                  <label>Shipping Line</label>
                  <model-list-select
                    :list="$store.getters['common/getAllShippingLineList']"
                    v-model="Filter.shippingLineFilter"
                    option-value="shippingId"
                    option-text="shippingLine"
                    placeholder="Select Shipping Line"
                    :isDisabled="
                      $sessionsStorage.get('designation') != 'Admin' ? true : false
                    "
                    @input="getProfitLossData('Normal')"
                  ></model-list-select>
                </b-col>
                <b-col md="3">
                  <label>Pickup</label>
                  <model-list-select
                    :list="$store.getters['commonDropdownMaster/getAllPickupList']"
                    v-model="Filter.PICKfilter"
                    option-value="pickupId"
                    option-text="pickupLocation"
                    placeholder="Select Pickup Location"
                  ></model-list-select>
                </b-col>
                <b-col md="3">
                  <label>Handover</label>
                  <model-list-select
                    :list="$store.getters['commonDropdownMaster/getAllHandoverList']"
                    v-model="Filter.HANDfilter"
                    option-value="pickupId"
                    option-text="pickupLocation"
                    placeholder="Select Handover Location"
                  ></model-list-select>
                </b-col>
                <b-col md="3">
                  <label>POR</label>
                  <model-list-select
                    @input="
                      getLocationList($event, 'All', 'finalAllPlaceDataPOR');
                      getProfitLossData('Normal');
                    "
                    @searchchange="getLocationList($event, 'All', 'finalAllPlaceDataPOR')"
                    :list="$store.getters['common/getAllPORList']"
                    v-model="Filter.PORfilter"
                    option-value="pickupId"
                    option-text="pickupLocation"
                    placeholder="Select POR"
                  ></model-list-select>
                </b-col>
                <b-col md="3">
                  <label>POD</label>
                  <model-list-select
                    @input="
                      getLocationList($event, 'All', 'finalAllPlaceDataPOD');
                      getProfitLossData('Normal');
                    "
                    @searchchange="getLocationList($event, 'All', 'finalAllPlaceDataPOD')"
                    :list="$store.getters['common/getAllPODList']"
                    v-model="Filter.PODfilter"
                    option-value="pickupId"
                    option-text="pickupLocation"
                    placeholder="Select POD"
                  ></model-list-select>
                </b-col>
                <b-col md="3">
                  <label>POL</label>
                  <model-list-select
                    @input="
                      getLocationList($event, 'All', 'finalAllPlaceDataPOD');
                      getProfitLossData('Normal');
                    "
                    @searchchange="getLocationList($event, 'All', 'finalAllPlaceDataPOD')"
                    :list="$store.getters['common/getAllPOLList']"
                    v-model="Filter.POLfilter"
                    option-value="pickupId"
                    option-text="pickupLocation"
                    placeholder="Select POL"
                  ></model-list-select>
                </b-col>
                <b-col md="3">
                  <label>FPOD</label>
                  <model-list-select
                    @input="
                      getLocationList($event, 'All', 'finalAllPlaceDataPOD');
                      getProfitLossData('Normal');
                    "
                    @searchchange="getLocationList($event, 'All', 'finalAllPlaceDataPOD')"
                    :list="$store.getters['common/getAllLocationDetailsFinalList']"
                    v-model="Filter.FPODfilter"
                    option-value="pickupId"
                    option-text="pickupLocation"
                    placeholder="Select Final Port of Discharge"
                  ></model-list-select>
                </b-col>
                <b-col md="3">
                  <label>Container Type</label>
                  <model-list-select
                    :list="$store.getters['common/getAllContainerTypeList']"
                    v-model="Filter.containerTypeFilter"
                    option-value="containerTypeId"
                    option-text="containerType"
                    placeholder="Select Container Type"
                    @input="getProfitLossData('Normal')"
                  ></model-list-select>
                </b-col>
                <b-col md="3">
                  <label>FCL/LCL</label>
                  <model-list-select
                    :list="flTypeList"
                    v-model="Filter.fclLclFilter"
                    option-value="flVal"
                    option-text="flText"
                    placeholder="Select FCL / LCL"
                    @input="getProfitLossData('Normal')"
                  ></model-list-select
                ></b-col>

                <b-col md="3">
                  <label>Transport Type</label>
                  <model-list-select
                    :list="transportTypeName"
                    v-model="Filter.transportTypeFilter"
                    option-value="transportTypeVal"
                    option-text="transportTypeText"
                    placeholder="Select Export / Import"
                    @input="getProfitLossData('Normal')"
                  ></model-list-select>
                </b-col>
                <b-col md="3">
                  <label>Ass. No Filter</label>
                  <b-form-input
                    type="text"
                    :formatter="capitalizeAll"
                    placeholder="Search Ass. No Filter"
                    id="assignmentNoFilter"
                    name="assignmentNoFilter"
                    autocomplete="off"
                    v-model="Filter.assignmentNoFilter"
                    @input="getProfitLossData('Normal')"
                  ></b-form-input>
                </b-col>
                <b-col md="6">
                  <label>Common Filter</label>
                  <b-form-input
                    type="text"
                    :formatter="capitalizeAll"
                    placeholder="Search Common Filter"
                    id="CommonFilter"
                    name="CommonFilter"
                    autocomplete="off"
                    v-model="Filter.CommonFilter"
                    @input="getProfitLossData('Normal')"
                  ></b-form-input>
                </b-col>
                <b-col md="12" class="mt-2">
                  <b-button
                    size="sm"
                    style="margin-left: auto"
                    class="ml-1 pull-right"
                    @click="clearFilter"
                    variant="outline-danger"
                    >Reset</b-button
                  >
                </b-col>
              </b-row>
            </b-collapse>
          </b-card>
        </div>

        <div>
          <b-card>
            <b-row
              class="mb-2 p-2 ml-2 mr-2"
              style="background-color: rgba(0, 0, 0, 0.03)"
            >
              <b-col md="12">
                <md-layout md-gutter class="pull-right">
                  <b-button
                    v-if="getProfitLossFilterList.length > 0"
                    variant="success"
                    class="ml-2"
                    @click="generatePLPDF"
                  >
                    Generate PDF
                  </b-button>

                  <b-button
                    :variant="
                      Filter.CommonFilter ||
                      Filter.ass_date ||
                      Filter.sob_date ||
                      Filter.branchfilter ||
                      Filter.shippingLineFilter ||
                      Filter.fclLclFilter ||
                      Filter.transportTypeFilter ||
                      Filter.clientIdFilter ||
                      Filter.PORfilter ||
                      Filter.PODfilter ||
                      Filter.POLfilter ||
                      Filter.FPODfilter ||
                      Filter.containerTypeFilter ||
                      Filter.assignmentNoFilter ||
                      Filter.QDFilter ||
                      Filter.QFlag ||
                      Filter.DFlag ||
                      Filter.dateRange.startDate ||
                      Filter.dateRange.endDate ||
                      Filter.dateRange.PICKfilter ||
                      Filter.dateRange.HANDfilter
                        ? 'outline-danger'
                        : 'outline-primary'
                    "
                    :class="visible ? null : 'collapsed'"
                    class="ml-2"
                    :aria-expanded="visible ? 'true' : 'false'"
                    aria-controls="collapse-4"
                    @click="visible = !visible"
                    >{{
                      Filter.CommonFilter ||
                      Filter.ass_date ||
                      Filter.sob_date ||
                      Filter.branchfilter ||
                      Filter.shippingLineFilter ||
                      Filter.fclLclFilter ||
                      Filter.transportTypeFilter ||
                      Filter.clientIdFilter ||
                      Filter.PORfilter ||
                      Filter.PODfilter ||
                      Filter.POLfilter ||
                      Filter.FPODfilter ||
                      Filter.containerTypeFilter ||
                      Filter.assignmentNoFilter ||
                      Filter.QDFilter ||
                      Filter.QFlag ||
                      Filter.DFlag ||
                      Filter.dateRange.startDate ||
                      Filter.dateRange.endDate ||
                      Filter.dateRange.PICKfilter ||
                      Filter.dateRange.HANDfilter
                        ? "Filter ON"
                        : "Filter OFF"
                    }}</b-button
                  >

                  <b-button
                    :disabled="ExcelBtnName != 'Export As Excel' ? true : false"
                    class="ml-2"
                    @click="
                      getReports('Assignment_Profit_Loss_Dashboard', 'Export As Excel')
                    "
                    variant="outline-info"
                  >
                    {{ ExcelBtnName }}
                    <b-spinner
                      v-if="ExcelBtnName != 'Export As Excel'"
                      small
                      label="Small Spinner"
                    ></b-spinner
                  ></b-button>

                  <b-button
                    :disabled="
                      ExcelBtnName1 != 'Export Pending Module As Excel' ? true : false
                    "
                    @click="
                      getReportsAss('ModuleIDPending', 'Export Pending Module As Excel')
                    "
                    variant="outline-info"
                    class="ml-2"
                  >
                    {{ ExcelBtnName1 }}
                    <b-spinner
                      v-if="ExcelBtnName1 != 'Export Pending Module As Excel'"
                      small
                      label="Small Spinner"
                    ></b-spinner
                  ></b-button>

                  <b-button variant="outline-info" @click="getPDF" class="ml-2">
                    <i class="fa fa-cloud-download" aria-hidden="true"></i>
                  </b-button>

                  <b-button variant="outline-secondary" @click="goBack" class="ml-2">
                    Back
                  </b-button>
                </md-layout>
              </b-col>
            </b-row>

            <b-row>
              <b-col md="12">
                <b-tabs v-model="PLtabIndex" pills card>
                  <b-row
                    v-if="pageType == 'Profit_less_15' || pageType == 'Loss_less_15'"
                  >
                    <b-col md="2">
                      <label>Condition</label>
                      <model-list-select
                        :list="perCondList"
                        v-model="perCon"
                        option-value="perVal"
                        option-text="perText"
                        placeholder="Select Condition"
                        @input="getTabStatus(pageType)"
                      ></model-list-select
                    ></b-col>
                    <b-col md="2">
                      <label>Condition Value</label>
                      <b-form-input
                        type="number"
                        :formatter="capitalizeAll"
                        placeholder="Search Condition Value"
                        id="perVal"
                        name="perVal"
                        autocomplete="off"
                        v-model="perVal"
                        @input="getTabStatus(pageType)"
                      ></b-form-input>
                    </b-col>
                  </b-row>
                  <div>
                    <b-pagination
                      limit="8"
                      align="center"
                      v-model="pagination.currentPage"
                      :per-page="pagination.perPage"
                      :total-rows="totalRows"
                      @change="onPageChange($event)"
                    ></b-pagination>
                  </div>

                  <div class="gutr">
                    <h5 class="text-muted pull-right mt-2">
                      <small v-if="isLoading == false">{{ totalRows }} Entries</small>
                    </h5>
                  </div>
                  <!-- {{getProfitLossFilterList}} -->
                  <b-tab title="Billing Locked" active @click="getTabStatus('Compare')">
                    <b-card-text>
                      <PL-Table
                        :tableData="getProfitLossFilterList"
                        :PLFields="PLFields"
                        :totalRowsCount="this.totalRows"
                      />
                    </b-card-text>
                  </b-tab>
                  <b-tab title="All" @click="getTabStatus('All')"
                    ><b-card-text>
                      <PL-Table
                        :tableData="getProfitLossFilterList"
                        :PLFields="PLFields"
                        :totalRowsCount="this.totalRows"
                      />
                    </b-card-text>
                  </b-tab>
                  <b-tab title="Profit" @click="getTabStatus('Profit')"
                    ><b-card-text>
                      <PL-Table
                        :tableData="getProfitLossFilterList"
                        :PLFields="PLFields"
                        :totalRowsCount="this.totalRows"
                      /> </b-card-text
                  ></b-tab>
                  <b-tab
                    :title="'Profit ' + perCon + ' ' + perVal + '%'"
                    @click="getTabStatus('Profit_less_15')"
                    ><b-card-text>
                      <!-- {{ filteredArrayCompute }} -->
                      <PL-Table
                        :tableData="getProfitLossFilterList"
                        :PLFields="PLFields"
                        :totalRowsCount="this.totalRows"
                      /> </b-card-text
                  ></b-tab>
                  <b-tab title="Profit Locked" @click="getTabStatus('Profit_locked')"
                    ><b-card-text>
                      <PL-Table
                        :tableData="getProfitLossFilterList"
                        :PLFields="PLFields"
                        :totalRowsCount="this.totalRows"
                      /> </b-card-text
                  ></b-tab>
                  <b-tab title="Loss" @click="getTabStatus('Loss')"
                    ><b-card-text>
                      <PL-Table
                        :tableData="getProfitLossFilterList"
                        :PLFields="PLFields"
                        :totalRowsCount="this.totalRows"
                      /> </b-card-text
                  ></b-tab>
                  <b-tab
                    :title="'Loss ' + perCon + ' ' + perVal + '%'"
                    @click="getTabStatus('Loss_less_15')"
                    ><b-card-text>
                      <!-- {{ filteredArrayCompute }} -->
                      <PL-Table
                        :tableData="getProfitLossFilterList"
                        :PLFields="PLFields"
                        :totalRowsCount="this.totalRows"
                      /> </b-card-text
                  ></b-tab>
                  <b-tab title="Loss Locked" @click="getTabStatus('Loss_locked')"
                    ><b-card-text>
                      <PL-Table
                        :tableData="getProfitLossFilterList"
                        :PLFields="PLFields"
                        :totalRowsCount="this.totalRows" /></b-card-text
                  ></b-tab>
                  <b-tab title="Normal" @click="getTabStatus('Normal')"
                    ><b-card-text>
                      <PL-Table
                        :tableData="getProfitLossFilterList"
                        :PLFields="PLFields"
                        :totalRowsCount="this.totalRows" /></b-card-text
                  ></b-tab>
                </b-tabs>
              </b-col>
            </b-row>
          </b-card>
          <!-- Control buttons-->
        </div>
      </div>

      <div></div>
    </div>
    <md-dialog-confirm
      :md-content-html="alert.content"
      :md-ok-text="alert.ok"
      ref="addPop"
    ></md-dialog-confirm>
  </div>
</template>

<script>
import DatePicker from "vue2-datepicker";
import axios from "axios";
import moment from "moment";
import { ModelListSelect } from "vue-search-select";
// import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import { URL_BASE, URL_BASE_DOC } from "../../helper/constant.js";
import { DateFormat, selectDateFormat } from "../../helper/filters";
import {
  lastVisitPage,
  globalPermissionStatus,
  GlobalGetLocation,
} from "../../helper/collection";
import DateRangePicker from "vue2-daterange-picker";
import ProfitLossService from "../../services/ProfitLossService.js";
import PLTable from "../common/plTable.vue";
import jsPDF from "jspdf";
import "jspdf-autotable";
import FilterAgencyModal from "../allModuleForm/filterAgencyModal.vue";
import FilterCBModal from "../allModuleForm/filterCBModal.vue";
import ClientCard from "../common/clientCard.vue";
import ShipmentTrackCard from "../common/ShipmentTrackCard.vue";
import CustomLoader from "../common/customLoader.vue";
export default {
  beforeMount() {
    this.getCurrentLastDate();
    this.$store.dispatch("setCurrentRoute", "/dashboard");
    this.$store.dispatch(
      "common/setAllBranchList",
      JSON.stringify({
        filter: "BranchList",
        active: "all",
      })
    );
    this.$store.dispatch(
      "common/setAllClientList",
      JSON.stringify({
        itemCode: "ClientList",
      })
    );
    this.$store.dispatch(
      "common/setAllShippingLineList",
      JSON.stringify({
        itemCode: "ShippingLineList",
      })
    );
    this.$store.dispatch(
      "commonDropdownMaster/setAllPickupDDList",
      JSON.stringify({
        itemCode: "AllPickupList",
      })
    );
    this.$store.dispatch(
      "commonDropdownMaster/setAllHandoverDDList",
      JSON.stringify({
        itemCode: "AllHandoverList",
      })
    );
    this.$store.dispatch(
      "commonDropdownMaster/setAllStuffingDDList",
      JSON.stringify({
        itemCode: "AllStuffingList",
      })
    );
    this.$store.dispatch(
      "common/setAllLocationDetailsFinalList",
      JSON.stringify({
        itemCode: "LocationDetailsFinalList",
      })
    );
    this.$store.dispatch(
      "common/setAllPORList",
      JSON.stringify({
        itemCode: "PORList",
      })
    );
    this.$store.dispatch(
      "common/setAllPODList",
      JSON.stringify({
        itemCode: "PODList",
        type: "Normal",
        Territory: "",
      })
    );
    this.$store.dispatch(
      "common/setAllPOLList",
      JSON.stringify({
        itemCode: "POLList",
      })
    );
    this.$store.dispatch(
      "common/setAllContainerTypeList",
      JSON.stringify({
        itemCode: "ContainerTypeList",
      })
    );
    if (
      this.$sessionsStorage.get("loginId") != undefined &&
      this.$sessionsStorage.get("loginId") != ""
    ) {
      if (
        globalPermissionStatus("Accounts") ||
        globalPermissionStatus("Dashboard_Access")
      ) {
        this.$store.dispatch("setCurrentRoute", "/P&LDashboard");

        this.getProfitLossData("Normal");
      } else {
        this.$router.push({
          path: "/dashboard",
        });
      }
    } else {
      this.$sessionsStorage.set("loginId", "");
      this.$router.push({
        path: "/Login/",
      });
    }
  },
  // <router-link to @click.native="$router.push('/dashboard/dashboardReportsDetails/500')">500</router-link>
  data() {
    return {
      pageType: "Compare",
      PLtabIndex: 1,
      perCondList: [
        {
          perVal: ">",
          perText: ">",
        },
        {
          perVal: ">=",
          perText: ">=",
        },
        {
          perVal: "<",
          perText: "<",
        },
        {
          perVal: "<=",
          perText: "<=",
        },
      ],
      perVal: 15,
      perCon: "<",
      flTypeList: [
        {
          flVal: "fcl",
          flText: "FCL",
        },
        {
          flVal: "lcl",
          flText: "LCL",
        },
      ],
      transportTypeName: [
        {
          transportTypeVal: "Export",
          transportTypeText: "Export",
        },
        {
          transportTypeVal: "Import",
          transportTypeText: "Import",
        },
      ],
      docURL: URL_BASE_DOC,
      ALLMODULE: "",
      JOBSERIES: "",
      lastVisitPage: this.$sessionsStorage.get("lastVisitPage"),
      Filter: {
        ass_date: "",
        sob_date: "",
        branchfilter: "",
        shippingLineFilter: "",
        fclLclFilter: "",
        transportTypeFilter: "",
        clientIdFilter: "",
        CommonFilter: "",
        PORfilter: "",
        PODfilter: "",
        POLfilter: "",
        FPODfilter: "",
        PICKfilter: "",
        HANDfilter: "",
        containerTypeFilter: "",
        assignmentNoFilter: "",
        QDFilter: "",
        QFlag: false,
        DFlag: false,
        dateRange: {
          startDate: "",
          endDate: "",
        },
        startDate: "",
        endDate: "",
      },
      getProfitLossList: [],
      getProfitLossFilterList: [],
      pagination: {
        currentPage: 1,
        perPage: 25,
        pageOptions: [5, 10, 15],
      },
      sortBy: null,
      sortDesc: false,
      sortDirection: "asc",
      filter: null,

      PLFields: [
        {
          key: "allModuleId",
          mainkey: "allModuleId",
          label: "SN",
          sortable: true,
          sortDirection: "ASC",
        },
        {
          key: "JOBNO",
          mainkey: "JOBNO",
          label: "JOB Det.",
          sortable: true,
          sortDirection: "ASC",
        },
        {
          key: "BillStatus",
          mainkey: "BillStatus",
          label: "Status",
          sortable: true,
          sortDirection: "ASC",
        },

        {
          key: "totExpVal",
          mainkey: "totExpVal",
          label: "Profit",
          sortable: true,
          sortDirection: "ASC",
        },
        {
          key: "notExistInvoice",
          mainkey: "notExistInvoice",
          label: "Not Exist Invoice",
          sortable: true,
          sortDirection: "ASC",
        },
        {
          key: "clientName",
          mainkey: "clientName",
          label: "Clinet/Sline",
          sortable: true,
          sortDirection: "ASC",
        },
      ],
      totalRows: 0,
      visible: false,
      ExcelBtnName: "Export As Excel",
      ExcelBtnName1: "Export Pending Module As Excel",
      CustomDateList: [
        {
          DVal: "Q1",
          DText: "Q1",
        },
        {
          DVal: "Q2",
          DText: "Q2",
        },
        {
          DVal: "Q3",
          DText: "Q3",
        },
        {
          DVal: "Q4",
          DText: "Q4",
        },
        {
          DVal: "H1",
          DText: "H1",
        },
        {
          DVal: "H2",
          DText: "H2",
        },
      ],
      branchList: [],
      openLeft: "left",
      showCal: false,
      startDate: "2017-09-05",
      endDate: "2017-09-15",
      dateRange: {
        startDate: "",
        endDate: "",
      },
      locale: {
        direction: "ltr",
        format: "mm/dd/yyyy",
        separator: " - ",
        applyLabel: "Apply",
        cancelLabel: "Cancel",
        weekLabel: "W",
        customRangeLabel: "Custom Range",
        daysOfWeek: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
        monthNames: [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Oct",
          "Nov",
          "Dec",
        ],
        firstDay: 0,
      },
      value1: [new Date(2019, 9, 8), new Date(2019, 9, 19)],
      value2: [],
      langType: {
        pickers: ["Today", "Yesterday", "This Month", "This Year"],
      },
      time: "",
      date: "",
      week: ["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"],

      langEnq: {
        pickers: ["", "", "previous 7 days", "previous 30 days"],
      },
      tabIndex: 0,

      isLoading: "",
      alert: {
        content: "Are you sure you want to delete ..!",
        ok: "ok",
      },
    };
  },

  mounted() {
    // this.JqueryFun()
  },
  filters: {
    moment(date) {
      return DateFormat(date);
    },
  },

  beforeDestroy() {},

  destroyed() {},

  components: {
    // Loading,
    DatePicker,
    ModelListSelect,
    DateRangePicker,
    PLTable,
    FilterAgencyModal,
    FilterCBModal,
    ClientCard,
    ShipmentTrackCard,
    CustomLoader,
  },

  computed: {
    // filteredArrayCompute() {
    //   if (this.perCon && this.perVal) {
    //       console.log("this.perCon =>", this.perCon);
    //       console.log("this.perVal=>", this.perVal);
    //       console.log("this.getProfitLossFilterList.length>0?this.getProfitLossFilterList:this.getProfitLossList=>", this.getProfitLossFilterList.length>0?this.getProfitLossFilterList:this.getProfitLossList);
    //       return this.getProfitLossFilterList.length>0?this.getProfitLossFilterList:this.getProfitLossList.filter(
    //         (item) =>
    //           (Math.floor(item.totPLPercentage) + this.perCon + this.perVal)
    //       );
    //       return data;
    //   }
    // },
  },
  watch: {
    perCon() {
      return this.getProfitLossFilterList.length > 0
        ? this.getProfitLossFilterList
        : this.getProfitLossList;
    },

    perVal() {
      return this.getProfitLossFilterList.length > 0
        ? this.getProfitLossFilterList
        : this.getProfitLossList;
    },
  },
  methods: {
    getCurrentLastDate() {
      this.Filter.QFlag = false;
      this.Filter.DFlag = false;

      var today = new Date();
      var firstDay = new Date(today.getFullYear(), today.getMonth(), 1);
      var lastDay = new Date(today.getFullYear(), today.getMonth() + 1, 0);

      var firstDay_dd = "";
      var firstDay_mm = "";
      var firstDay_yyyy = "";

      var lastDay_dd = "";
      var lastDay_mm = "";
      var lastDay_yyyy = "";
      if (this.Filter.QDFilter) {
        var Qdate = this.Filter.QDFilter;
        switch (Qdate) {
          case "Q1": {
            var firstDay = new Date(today.getFullYear(), 3);
            var lastDay = new Date(firstDay.getFullYear(), firstDay.getMonth() + 3, 0);
            firstDay_dd = String(firstDay.getDate()).padStart(2, "0");
            firstDay_mm = String(firstDay.getMonth() + 1).padStart(2, "0"); //January is 0!
            firstDay_yyyy = firstDay.getFullYear();

            lastDay_dd = String(lastDay.getDate()).padStart(2, "0");
            lastDay_mm = String(lastDay.getMonth() + 1).padStart(2, "0"); //January is 0!
            lastDay_yyyy = lastDay.getFullYear();
            firstDay =
              (firstDay_mm > 3 ? firstDay_yyyy - 1 : firstDay_yyyy) +
              "/" +
              firstDay_mm +
              "/" +
              firstDay_dd; //2018-06-01
            lastDay =
              (lastDay_mm > 3 ? lastDay_yyyy - 1 : firstDay_yyyy) +
              "/" +
              lastDay_mm +
              "/" +
              lastDay_dd; //2018-06-01
            break;
          }
          case "Q2": {
            var firstDay = new Date(today.getFullYear(), 6);
            var lastDay = new Date(firstDay.getFullYear(), firstDay.getMonth() + 3, 0);

            firstDay_dd = String(firstDay.getDate()).padStart(2, "0");
            firstDay_mm = String(firstDay.getMonth() + 1).padStart(2, "0"); //January is 0!
            firstDay_yyyy = firstDay.getFullYear();

            lastDay_dd = String(lastDay.getDate()).padStart(2, "0");
            lastDay_mm = String(lastDay.getMonth() + 1).padStart(2, "0"); //January is 0!
            lastDay_yyyy = lastDay.getFullYear();
            firstDay =
              (firstDay_mm > 3 ? firstDay_yyyy - 1 : firstDay_yyyy) +
              "/" +
              firstDay_mm +
              "/" +
              firstDay_dd; //2018-06-01
            lastDay =
              (lastDay_mm > 3 ? lastDay_yyyy - 1 : firstDay_yyyy) +
              "/" +
              lastDay_mm +
              "/" +
              lastDay_dd; //2018-06-01
            break;
          }
          case "Q3": {
            var firstDay = new Date(today.getFullYear(), 9);
            var lastDay = new Date(firstDay.getFullYear(), firstDay.getMonth() + 3, 0);

            firstDay_dd = String(firstDay.getDate()).padStart(2, "0");
            firstDay_mm = String(firstDay.getMonth() + 1).padStart(2, "0"); //January is 0!
            firstDay_yyyy = firstDay.getFullYear();

            lastDay_dd = String(lastDay.getDate()).padStart(2, "0");
            lastDay_mm = String(lastDay.getMonth() + 1).padStart(2, "0"); //January is 0!
            lastDay_yyyy = lastDay.getFullYear();
            firstDay =
              (firstDay_mm > 3 ? firstDay_yyyy - 1 : firstDay_yyyy) +
              "/" +
              firstDay_mm +
              "/" +
              firstDay_dd; //2018-06-01
            lastDay =
              (lastDay_mm > 3 ? lastDay_yyyy - 1 : firstDay_yyyy) +
              "/" +
              lastDay_mm +
              "/" +
              lastDay_dd; //2018-06-01
            break;
          }
          case "Q4": {
            var firstDay = new Date(today.getFullYear(), 12);
            var lastDay = new Date(firstDay.getFullYear(), firstDay.getMonth() + 3, 0);

            firstDay_dd = String(firstDay.getDate()).padStart(2, "0");
            firstDay_mm = String(firstDay.getMonth() + 1).padStart(2, "0"); //January is 0!
            firstDay_yyyy = firstDay.getFullYear();

            lastDay_dd = String(lastDay.getDate()).padStart(2, "0");
            lastDay_mm = String(lastDay.getMonth() + 1).padStart(2, "0"); //January is 0!
            lastDay_yyyy = lastDay.getFullYear();

            firstDay =
              (firstDay_mm > 3 ? firstDay_yyyy : firstDay_yyyy - 1) +
              "/" +
              firstDay_mm +
              "/" +
              firstDay_dd; //2018-06-01
            lastDay =
              (lastDay_mm > 3 ? lastDay_yyyy : firstDay_yyyy - 1) +
              "/" +
              lastDay_mm +
              "/" +
              lastDay_dd; //2018-06-01
            break;
          }
          case "H1": {
            var firstDay = new Date(today.getFullYear(), 3);
            var lastDay = new Date(firstDay.getFullYear(), firstDay.getMonth() + 6, 0);

            firstDay_dd = String(firstDay.getDate()).padStart(2, "0");
            firstDay_mm = String(firstDay.getMonth() + 1).padStart(2, "0"); //January is 0!
            firstDay_yyyy = firstDay.getFullYear();

            lastDay_dd = String(lastDay.getDate()).padStart(2, "0");
            lastDay_mm = String(lastDay.getMonth() + 1).padStart(2, "0"); //January is 0!
            lastDay_yyyy = lastDay.getFullYear();

            firstDay =
              (firstDay_mm > 3 ? firstDay_yyyy - 1 : firstDay_yyyy) +
              "/" +
              firstDay_mm +
              "/" +
              firstDay_dd; //2018-06-01
            lastDay =
              (lastDay_mm > 3 ? lastDay_yyyy - 1 : firstDay_yyyy) +
              "/" +
              lastDay_mm +
              "/" +
              lastDay_dd; //2018-06-01
            break;
          }
          case "H2": {
            var firstDay = new Date(today.getFullYear(), 9);
            var lastDay = new Date(firstDay.getFullYear(), firstDay.getMonth() + 6, 0);

            firstDay_dd = String(firstDay.getDate()).padStart(2, "0");
            firstDay_mm = String(firstDay.getMonth() + 1).padStart(2, "0"); //January is 0!
            firstDay_yyyy = firstDay.getFullYear();

            lastDay_dd = String(lastDay.getDate()).padStart(2, "0");
            lastDay_mm = String(lastDay.getMonth() + 1).padStart(2, "0"); //January is 0!
            lastDay_yyyy = lastDay.getFullYear();

            firstDay =
              (firstDay_mm > 3 ? firstDay_yyyy - 1 : firstDay_yyyy) +
              "/" +
              firstDay_mm +
              "/" +
              firstDay_dd; //2018-06-01
            lastDay =
              (lastDay_mm > 3 ? lastDay_yyyy : firstDay_yyyy) +
              "/" +
              lastDay_mm +
              "/" +
              lastDay_dd; //2018-06-01
            break;
          }
          default: {
            // alert(">41");
          }
        }
        this.Filter.QFlag = false;
        this.Filter.DFlag = true;
      } else if (this.dateRange.startDate && !this.Filter.QDFilter) {
        this.Filter.QFlag = true;
        this.Filter.DFlag = false;
      }

      var dd = String(today.getDate()).padStart(2, "0");
      var mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
      var yyyy = today.getFullYear();
      today = yyyy + "/" + mm + "/" + dd; //2018-06-01
      this.startDate = today;
      this.Filter.dateRange = {
        startDate: firstDay,
        endDate: lastDay,
      };
      // alert(this.Filter.QDFilter)
      this.getProfitLossData("Normal");
    },

    goBack() {
      window.history.go(-1);
    },

    clearFilter() {
      this.perVal = 15;
      this.perCon = "<";
      this.totalRows = 0;
      this.pageType = "Compare";
      this.getProfitLossList = [];
      this.getProfitLossFilterList = [];
      this.Filter = {
        ass_date: "",
        sob_date: "",
        branchfilter: "",
        shippingLineFilter: "",
        fclLclFilter: "",
        transportTypeFilter: "",
        CommonFilter: "",
        clientIdFilter: "",
        PORfilter: "",
        PODfilter: "",
        POLfilter: "",
        FPODfilter: "",
        PICKfilter: "",
        HANDfilter: "",
        containerTypeFilter: "",
        assignmentNoFilter: "",
        QDFilter: "",
        QFlag: false,
        DFlag: false,
        dateRange: {
          startDate: "",
          endDate: "",
        },
        startDate: "",
        endDate: "",
      };
      this.dateRange = {
        startDate: "",
        endDate: "",
      };
      this.getProfitLossList = [];
    },
    getCurrentDateTime() {
      const options = {
        day: "numeric",
        month: "long",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hour12: true,
      };
      const now = new Date();
      // const day = String(now.getDate()).padStart(2, "0");
      // const month = String(now.getMonth() + 1).padStart(2, "0");
      // const year = now.getFullYear();
      // const hours = String(now.getHours()).padStart(2, "0");
      // const minutes = String(now.getMinutes()).padStart(2, "0");
      // const seconds = String(now.getSeconds()).padStart(2, "0");

      // return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`
      return now.toLocaleString("en-GB", options);
    },
    generatePLPDF() {
      // const doc = new jsPDF();
      let data = this.getProfitLossFilterList;

      // PDF A4 Size COde Start
      const doc = new jsPDF("p", "mm", "a4"); // Specify page size as 'a4'

      if (data.length > 0) {
        // Add content to the PDF using array map

        // Create an HTML table
        const table = document.createElement("table");
        table.innerHTML = `
        <thead>
          <tr>
            <th>SN.</th>
            <th>JOB NO.</th>
            <th>JOB Date</th>
            <th>PL Status</th>
            <th>Exp Amt</th>
            <th>Inv Amt</th>
            <th>PL Amt</th>
            <th>PL %</th>
          </tr>
        </thead>
        <tbody>
          ${data
            .map(
              (item, index) =>
                `<tr style="background-color: ${
                  item.totPLLabel == "Profit"
                    ? "#28a745"
                    : item.totPLLabel == "Loss"
                    ? "#dc3545"
                    : ""
                }"><td>${parseInt(index + 1)}</td>
                <td>${item.JOBNO}<br/>${
                  item.notExistInvoice != null
                    ? "Not Recd From Tally Inv :" + item.notExistInvoice
                    : ""
                }<br/>${
                  item.notExistOSDR != null
                    ? "Not Recd From Tally OSDR :" + item.notExistOSDR
                    : ""
                }<br/>${
                  item.notExistOSCR != null
                    ? "Not Recd From Tally OSCR :" + item.notExistOSCR
                    : ""
                }</td><td>${item.JOBDate}</td>
                <td>${item.totPLLabel}</td>
                <td>${item.totExpVal}</td>
                <td>${item.totInvVal}</td>
                <td>${item.totPLVal}</td>
                <td>${item.totPLPercentage}</td>
                
                </tr>`
            )
            .join("")}
        <tr><td colspan='4'><b>Report Generated At : </b></td><td colspan='4'>${this.getCurrentDateTime()}</td></tr></tbody>
        
      `;
        doc.autoTable({
          html: table,
          startY: 6,
          margin: { top: 4 },
          styles: { fontSize: 7 },
        });

        // Save the PDF
        doc.save(
          this.pageType +
            "_Assignment_PL_Dashboard_REPORTS_" +
            this.getCurrentDateTime() +
            ".pdf"
        );
      }
    },
    filteredArray(type) {
      if (this.pageType == "Compare") {
        return this.getProfitLossList.filter((item) => item._rowVariant !== "");
      } else if (this.pageType == "Profit_locked") {
        return this.getProfitLossList.filter((item) => item._rowVariant === "success");
      } else if (this.pageType == "Profit_less_15") {
        return this.getProfitLossList.filter(
          (item) =>
            eval(item.totPLPercentage + this.perCon + this.perVal) &&
            item.totExpVal > 0 &&
            item.totPLLabel === "Profit"
        );
      } else if (this.pageType == "Loss_less_15") {
        return this.getProfitLossList.filter(
          (item) =>
            eval(Math.abs(item.totPLPercentage) + this.perCon + this.perVal) &&
            item.totExpVal > 0 &&
            item.totPLLabel === "Loss"
        );
      } else if (this.pageType == "Loss_locked") {
        return this.getProfitLossList.filter((item) => item._rowVariant === "danger");
      } else {
        return this.getProfitLossList.filter((item) => item.totPLLabel === this.pageType);
      }
    },
    async getTabStatus(type) {
      this.pageType = type;
      console.log("type=>", type);
      if (type == "All") {
        this.getProfitLossFilterList = this.getProfitLossList;
      } else {
        this.getProfitLossFilterList = this.filteredArray(type);
      }
      this.totalRows = this.getProfitLossFilterList.length;
    },
    getReports(id, btnName) {
      this.ExcelBtnName = "Downloading Please Wait .....";
      this.getProfitLossData("Excell");
    },
    getReportsAss(id, btnName) {
      let payload = {
        excelId: id,
        Filter: this.Filter,
      };
      this.ExcelBtnName1 = "Downloading Please Wait...";
      this.$store.dispatch("common/setAllPendingReverseTallyExcel", payload);
      let ExcelName = "";
      if (this.$store.getters["common/getAllPendingReverseTallyExcel"]) {
        this.ExcelBtnName1 = btnName;
        ExcelName = this.$store.getters["common/getAllPendingReverseTallyExcel"];
      }
    },
    getProfitLossData(type) {
      this.totalRows = 0;
      this.getProfitLossList = [];
      this.isLoading = true;
      let payload = {
        itemCode: "ProfitLossDashboard",
        Filter: this.Filter,
        type: type,
        pageType: this.pageType,
        perVal: this.perVal,
        perCon: this.perCon,
      };

      ProfitLossService.getAllProfitLoss(payload)
        .then((response) => {
          const { data, status, statusText } = response;
          if (status == 200 && data) {
            this.isLoading = false;
            if (type == "Excell") {
              this.ExcelBtnName = "Export As Excel";
              if (data.getProfitLossList.length > 0) {
                this.getProfitLossList = data.getProfitLossList;
                this.totalRows = data.getProfitLossList.length;
              }
              window.location.href =
                `https://uploadsp.pridel.com/Pridel_Reports/` + data.excelName;
            } else {
              if (data.getProfitLossList.length > 0) {
                this.getProfitLossList = data.getProfitLossList;
                this.getProfitLossFilterList = this.getProfitLossList;
                this.totalRows = data.getProfitLossList.length;
                console.log(" getProfitLossList response=>", data);
              }
            }
            this.getTabStatus(this.pageType);
          }
        })
        .catch((error) => {
          console.log("Catch on getProfitLossList Error: ", error);
        });
    },

    getPDF() {
      var HTML_Width = $("#ProfitLossDashboardpdf").width();
      var HTML_Height = $("#ProfitLossDashboardpdf").height();

      var top_left_margin = 15;
      var PDF_Width = HTML_Width + top_left_margin * 2;
      var PDF_Height = PDF_Width * 1.5 + top_left_margin * 2;
      var canvas_image_width = HTML_Width;
      var canvas_image_height = HTML_Height;

      var totalPDFPages = Math.ceil(HTML_Height / PDF_Height) - 1;

      html2canvas($("#ProfitLossDashboardpdf")[0], { allowTaint: true }).then(function (
        canvas
      ) {
        canvas.getContext("2d");

        var imgData = canvas.toDataURL("image/jpeg", 1.0);
        var pdf = new jsPDF("p", "pt", [PDF_Width, PDF_Height]);
        pdf.addImage(
          imgData,
          "JPG",
          top_left_margin,
          top_left_margin,
          canvas_image_width,
          canvas_image_height
        );

        for (var i = 1; i <= totalPDFPages; i++) {
          pdf.addPage(PDF_Width, PDF_Height);
          pdf.addImage(
            imgData,
            "JPG",
            top_left_margin,
            -(PDF_Height * i) + top_left_margin * 4,
            canvas_image_width,
            canvas_image_height
          );
        }

        pdf.save("PL_Dashboard_Document_" + new Date() + ".pdf");
      });
    },
  },
};
</script>
<style scoped>
.formCard {
  border: none !important;
  padding: 0px;
}
.modal fade show d-block {
  background: none;
}
</style>



// WEBPACK FOOTER //
// profitlossDashboard.vue?571942cf